<template>
  <el-dialog
    :visible.sync="innerVisible"
    :title="$t('Price.ConfigSurchargeFcl')"
    width="740px"
    :close-on-click-modal="false"
    :destroy-on-close="true"
    top="5vh"
    custom-class="surcharge-fcl-form-dialog details-view"
    @close="cancel"
  >
    <configure-the-surcharge
      config-module="22320104"
      :grid-options="gridOptions"
      :select-length="selectLength"
      @confirm="onConfirm"
      @cancel="onCancel"
    />
  </el-dialog>
</template>

<script>
import ConfigureTheSurcharge from '@/views/cargo/v0/Price/TariffTable/configureTheSurcharge'
import CargoAgGridAdvanceSelectEditor from '@/components/Cargo/Common/CargoAgGridAdvanceSelectEditor'
import CargoAgGridSelectEditor from '@/components/Cargo/Common/CargoAgGridSelectEditor'

export default {
  name: 'ConfigureTheSurchargeDialog',
  components: { ConfigureTheSurcharge },
  props: {
    visible: {
      type: Boolean,
      default: () => false
    }
  },
  data() {
    return {
      addConfigureTheSurchargeDialog: {
        visible: false
      },
      selectLength: 0,
      addRowData: [],
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        singleClickEdit: true,
        onRowDoubleClicked: this.onRowDoubleClicked,
        onSelectionChanged: event => {
          const rows = event.api.getSelectedRows()
          this.selectLength = rows.length
        },
        // 添加编辑组件
        frameworkComponents: {
          CargoAgGridAdvanceSelectEditor,
          CargoAgGridSelectEditor
        }
      }
    }
  },
  computed: {
    innerVisible: {
      get() {
        return this.visible
      },
      set(val) {
        if (!val) {
          this.selectRow = null
          this.$emit('close', val)
        } else {
          this.$emit('open', val)
        }
      }
    },
    isZh() {
      return this.$store.getters.language === 'zh'
    }
  },
  methods: {
    cancel() {
      this.$emit('onClose')
    },
    onCancel() {
      this.$emit('onClose')
    },
    onConfirm() {
      this.$emit('reload')
    }
  }
}
</script>

<style scoped>
</style>
<style lang="scss">
.surcharge-fcl-form-dialog{
  input[type="number"]{
    text-align: right;
  }
}
</style>
